module.exports = __webpack_public_path__ + "img/SCN-Lewis-Structures.fe809d91.png";